import { FC, useEffect, useState } from "react"
import { LoginCallback, useOktaAuth } from "@okta/okta-react"
import { Box } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { UText, UButton } from "../ui-component"
import { clearLocalStorage } from "@/core/config/okta.config"

const LoginCallBackWrapper: FC = (props) => {
  const { t } = useTranslation("common")
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const { oktaAuth } = useOktaAuth()

  const handleError = (errObj) => {
    console.error("Login error:", errObj);
    setError(errObj.error.error_description || "An unknown error occurred during login.");
  };

  useEffect(() => {
    const checkSessions = async () => {
      const session = await oktaAuth.session.exists()
      if (session) {
        await oktaAuth.tokenManager.clear(); // Clear stored tokens
        await oktaAuth.closeSession(); // End session without redirect
        clearLocalStorage();
      } 
    }
    if(error){
      checkSessions()
    }
 }, [error])

  if (error) {
    return (
      <Box sx={{ textAlign: "center", marginTop: "50px" }}>
        <UText variant={"h4"} color={"text"} sxProp={{ textAlign: "center", display: "block", paddingBottom: "15px" }}>
          {t("auth.authenticationError")}
        </UText>
        <UText variant={"body1"} color={"error"} sxProp={{ textAlign: "center" }}>
          {error}
        </UText>
        <UButton
          sxProp={{ mt: 3, width: "100%" }}
          variant={"contained"}
          btnType={"submit"}
          btnText={t("button.backtologin")}
          onClickHandler={() => navigate("/")}
        />
      </Box>
    );
  }

  return <LoginCallback {...props} errorComponent={handleError} />;

};

export default LoginCallBackWrapper;